// The App Store URL isn't actually a constant, since it changes with each landing page.
// Use ../utils/getAppStoreUrl.js instead.

export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.margin&hl=en_US&gl=US';

export const WAITLIST_URL = 'https://forms.gle/wJzkao5gJcopqq5K6';
